"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "orria": {
    "4a9005a5": [{
      "hkey": "663fb1e0",
      "slug": "piano-vetrale",
      "name": "Piano-Vetrale",
      "primary": true,
      "skipSearch": false
    }],
    "piano": [{
      "hkey": "663fb1e0",
      "slug": "piano-vetrale",
      "name": "Piano-Vetrale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "orria"
    }],
    "c4533c98": [{
      "hkey": "663fb1e0",
      "slug": "piano-vetrale",
      "name": "Piano-Vetrale",
      "primary": true,
      "skipSearch": false
    }],
    "vetraie": [{
      "hkey": "663fb1e0",
      "slug": "piano-vetrale",
      "name": "Piano-Vetrale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "orria"
    }]
  }
};
exports["default"] = _default;